if (!customElements.get("sticky-add-to-cart")) {
  customElements.define(
      'sticky-add-to-cart',
      class StickyAddToCart extends HTMLElement {
        constructor() {
          super();
          this.stickyAddToCart = this.querySelector("#stickyAddToCart");
          this.handleAddToCart = this.handleAddToCart.bind(this);
          this.observeFormVisibility = this.observeFormVisibility.bind(this);
          this.refreshElements = this.refreshElements.bind(this);
        }
        connectedCallback() {
          this.refreshElements();
          if (this.productForm) {
            this.observer = new IntersectionObserver(this.observeFormVisibility, { threshold: 0.1 });
            this.observer.observe(this.productForm);
          }
          if (this.stickyAddToCart) {
            this.stickyAddToCart.addEventListener("click", this.handleAddToCart);
          }
          document.addEventListener('shopify:section:load', this.refreshElements);
          document.addEventListener('variant:change', this.refreshElements);
        }
        refreshElements() {
          this.productWrapper = document.querySelector(".product__info-wrapper");
          this.productForm = this.productWrapper?.querySelector(".product-form");
          this.productPriceContainer = this.productWrapper?.querySelector(".product__price .price__container");
          if (this.observer && this.productForm) {
            this.observer.disconnect();
            this.observer.observe(this.productForm);
          }
        }
        observeFormVisibility(entries) {
          const formVisible = entries[0]?.isIntersecting;
          this.classList.toggle("show", !formVisible);
        }
        handleAddToCart(e) {
          e.preventDefault();
          this.refreshElements(); // Asegurar que usamos la versión actualizada
          if (!this.productPriceContainer) return;
          const offset = 100;
          const elementTop = this.productPriceContainer.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: elementTop - offset, behavior: "smooth" });
        }
      }
  );
}
